import { useCompactNumberFormatter } from '@shared/hooks/useCompactNumberFormatter';

/**
 * Hook for formatting review counts in a compact way (e.g., 1000 -> 1K) using the current locale.
 */
export const useReviewCountFormatter = () => {
  return useCompactNumberFormatter().formatCompactNumber;
};

/**
 * Formats a user rating number to one decimal place.
 *
 * eg. 8.5 -> "8.5", 9 -> "9.0"
 */
export const formatUserRatingNumber = (rating: number): string => {
  return rating.toFixed(1);
};

export const createQueryParamsUpdater = (params: URLSearchParams) => (key: string, value: string | null) => {
  if (value === null) {
    params.delete(key);
  } else {
    params.set(key, value);
  }
};
